seedWebApp.controller('StoreOrdersCtrl', ['$scope', 'StoreService', 'TranslationService', '$uibModal', '$timeout', '$routeParams', 'ToastService', 'AllocService',
    function ($scope, StoreService, TranslationService, $uibModal, $timeout, $routeParams, ToastService, AllocService) {
        $scope.translation = TranslationService.getActiveTranslation();

        getColumnLayout();

        $scope.openOrderID = $routeParams.id;
        $scope.openTab = $routeParams.tab;
        
        $scope.findOrderID = function (orderID) {
            console.log('findOrderID');
            //$scope.filterString = orderID;

            $scope.searchMode();
        };

        $scope.prefs = {
            name: 'StoreOrdersGrid',
            selContact: null,
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
            doubleHeader: true,
        };

        Date.prototype.addDays = function (days) {
            this.setDate(this.getDate() + days);
            return this;
        };

        Date.prototype.getDateWithoutTime = function () {
            return new Date(this.toDateString());
        };

        //VERIFICA FILTROS NA URL
        if ($scope.openOrderID) {
            console.log('openOrderID: ' + $scope.openOrderID + ' ' + $scope.openTab);
            $scope.filterString = '#'+ $scope.openOrderID;
            //$scope.prefs.parentFilter = null;

            $timeout(function () {
                console.log('TENTA ABRIR MODAL');
                if ($scope.prefs.items && $scope.prefs.items.length == 1) {
                    var item = $scope.prefs.items[0];
                    $scope.prefs.customEdit(item, $scope.openTab);
                }                
            }, 1000);
        }
        

        var today = new Date();
        today = today.getDateWithoutTime();
        $scope.prefs.parentFilter = new Date(today.addDays(-60));
        
        $scope.prefs.customExcel = function (data, eventArgs) {
            //console.log('customExcel');
            //console.log(data);
            var result = formatExcelData(data);
            alasql('SELECT * INTO XLSX("' + eventArgs + '.xlsx", {header:true}) FROM ?', [result]);
        };

        
        //
        /* FICOU NO INICIO
        var today = new Date();
        today = today.getDateWithoutTime();
        $scope.prefs.parentFilter = new Date(today.addDays(-60));
        */

        $scope.resetService = StoreService.resetCache;
        $scope.loadColumns = StoreService.getUserOrdersColumns;
        $scope.loadService = StoreService.getUserOrders;        

        function isValidDate(date) {
            return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
        }

        $scope.dateChanged = function () {
            //console.log('date has changed: ' + $scope.prefs.parentFilter);
            $scope.$broadcast('onParentFilterChanged', $scope.filterString);
            $timeout(function () {                
                if (isValidDate($scope.prefs.parentFilter) || !$scope.prefs.parentFilter || $scope.prefs.parentFilter == '') {
                    $scope.doRefresh();
                }
            }, 50);
        };

        $scope.archivedChanged = function (showArchived) {
            //console.log('ARCHIVECHANGED ' + showArchived);
            if (showArchived) {
                $scope.loadService = StoreService.getUserOrdersArchived;
                //console.log('ARCHIVECHANGED ARQCHIVED!!!!');
            }
            else {
                $scope.loadService = StoreService.getUserOrders;
                //console.log('ARCHIVECHANGED NOT NOT');
            }
            $timeout(function () {
                $scope.doRefresh();
            }, 50);

        };

        $scope.getIDClass = function (item) {
            return 'agp-color';
        };

        $scope.statusClass = function (item) {
            return 'Status_Shipping Status_' + item;
        };

        $scope.customClass = function (item) {
            return 'status-card Status_' + item;
        };

        $scope.sapIDClass = function (item) {
            return 'sap-order';
        };

        $scope.updateTypeClass = function (item) {
            return 'sd-update-type ' + item;
        };

        $scope.getDateClass = function (item) {
            var res = 'sd-reservation-date';
            //var date = new Date();
            //var firstDay = new Date(date.getFullYear(), date.getMonth(), 0);
            if (AllocService.isLastMonth(item)) {
                res += ' sd-date-late';
            }
            return res;
        };

        $scope.dateFormat = "MMM dd, yyyy";

        function generateDefaultColumns() {
            $scope.columns = [
                { name: 'ContractNumber', display: 'PO#', width: 5, filterOptions: [] },
                { name: 'ContactID', display: 'Customer', width: 5, customClass: $scope.getIDClass, filterOptions: [] },
                { name: 'ProcExpID', display: 'Invoice#', width: 5, filterOptions: [] },
                { name: 'StatusID', display: 'Status', filterOptions: [], width: 5, translationPrefix: 'Status_', tdClass: $scope.statusClass },
                { name: 'SkuPatterns', display: 'Patterns', width: 5, dataType: 'tags' },
                { name: 'CustomerDate', display: 'Customer Date', width: 5 },
                { name: 'PORequestedShipment', display: 'PO Req Shipment', dataType: 'date', format: $scope.dateFormat, IsActive: true, width: 5 },
                { name: 'PlaceOfDelivery', display: 'Place Delivery', width: 5, filterOptions: [] },
                { name: 'PortOfDischarge', display: 'Port Discharge', width: 5, filterOptions:[] },
                { name: 'DateOfProduction', display: 'Date Production', width: 5 },
                { name: 'Vessel_Voyage', display: 'Vessel/ VG#', width: 5, filterOptions: [] },
                { name: 'ActualShippingDateDisplayable', display: 'Actual Ship Date', dataType: 'date', format: $scope.dateFormat, width: 5, filterOptions: [] },
                { name: 'ETAPortOfDischarge', display: 'ETA Port Discharge', dataType: 'date', format: $scope.dateFormat, width: 5 },
                { name: 'ETAPlaceOfDelivery', display: 'ETA Place Delivery', dataType: 'date', format: $scope.translation.dateFormat, width: 5 },
                { name: 'BillOfLadding', display: 'BL#', width: 5 },
                { name: 'ContainerID', display: 'Container', width: 5, filterOptions: [] },
                { name: 'BookingID', display: 'Booking', width: 5 },
                { name: 'ShipOwner', display: 'Ship Owner', width: 5 },
                { name: 'ShippingCompany', display: 'Shipping Company', width: 5 },
                { name: 'ReservationDate', display: 'PO Date', dataType: 'date', format: $scope.dateFormat, filterOptions: [], width: 5 },
                { name: 'PlantID', display: 'Plant', width: 5, filterOptions: [] },
                { name: 'TranshipmentDate', display: 'Transhipment', title: 'Transhipment Date', dataType: 'date', format: $scope.dateFormat, filterOptions: [], width: 5 },
                //{ name: 'TranshipmentVessel', display: 'Tra Vessel', title:'Transhipment Vessel', width: 5, filterOptions: [] },
            ];
            //console.log('defaultColumns');
            //console.log($scope.loggedUser);
            if ($scope.loggedUser && $scope.loggedUser.UserID == 'jamesm@seed.com.br') {
                $scope.columns.push({ name: 'RecalcDate', display: 'Dt Recalc', dataType: 'date', format: $scope.dateFormat, filterOptions: [], width: 5 });
            }            
        }


        $scope.loadTotal = function () {
            $scope.loadingTotal = true;
            StoreService.getUserOrdersCount().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data.TotalItems;
                $scope.importDate = response.data.ImportDate;
            });
        };

        $scope.loadTotal();

        $scope.searchMode = function () {
            console.log('searchMode');
            $scope.$broadcast('inputSearch', $scope.filterString);            
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
            $scope.loadTotal();
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'ShippingSchedule');
        };

        $scope.doRecalcExpired = function () {
            var toastID = ToastService.createToast('Calculando...', '', 0, 'wait');
            $scope.executing = true;
            StoreService.recalcExpired().then(function (response) {
                ToastService.updateToast(toastID, 'Calculo ok!', '', 4000, 'success');
                $scope.executing = false;
                $scope.doRefresh();
            },
                function (error) {
                    $scope.saving = false;
                    ToastService.updateToast(toastID, 'Erro cálculo!', '', 4000, 'error');
                });
        };

        $scope.prefs.customEdit = function (item, openTab) {
            var modalInstance = StoreService.openOrderDetailModal(item.OrderID, null, null, openTab);
            modalInstance.result.then(
                function (order) {
                    $scope.updateOrder(item);
                },
                function (expiredJustification) {
                    item.ExpiredJustification = expiredJustification;
                }
            );
        };

        $scope.$on('onOrderUpdated', function (event, orderID) {
            console.log('onOrderUpdated ' + orderID);
            if ($scope.prefs.items) {
                for (var i = 0; i < $scope.prefs.items.length; i++) {
                    var it = $scope.prefs.items[i];
                    if (it.OrderID == orderID) {
                        $scope.updateOrder(it);
                    }
                }
            }            
        })

        //ATUALIZA DADOS DO PEDIDO
        $scope.updateOrder = function (order) {         
            StoreService.getUserOrder(order.OrderID).then(function (response) {
                //console.log('UPDATE ORDER ' + order.OrderID);
                var data = response.data[0];
                if (data) {                    
                    for (var i = 0; i < $scope.columns.length; i++) {
                        var col = $scope.columns[i];
                        order[col.name] = data[col.name];
                        if (col.dataType == 'statusIDs') {
                            order.StatusIDs = data.StatusIDs;
                        }
                    }
                    
                }
            });
        };

        
        $scope.doAddOrder = function () {            
            $scope.contactID = $scope.loggedUser.ContactID;
            //console.log('CONTATO LIGADO -> ' + $scope.contactID);
            //console.log($scope.loggedUser);
            var modalInstance = StoreService.openOrderDetailModal(null, $scope.contactID);
            modalInstance.result.then(
                function () {
                    //console.log('INSERT SALES ORDER');
                    $scope.doRefresh();
                    //$scope.loadContactOrders(contactID);
                },
                function () {
                }
            );
        };

        $scope.doRecalc = function () {
            var toastID = ToastService.createToast('Recalculando...', '', 0, 'wait');
            $scope.executing = true;
            StoreService.recalcShippingSchedule().then(function (response) {
                ToastService.updateToast(toastID, 'Calculo ok!', '', 4000, 'success');
                $scope.executing = false;
                $scope.doRefresh();
            },
                function (error) {
                    $scope.saving = false;
                    //console.log(error);
                    var errMsg = '';
                    if (error.data && error.data.ExceptionMessage) {
                        //console.log('save error: ');
                        //console.log(error.data);
                        //var errorMsg = error.data.Message;
                        errMsg = error.data.ExceptionMessage;
                    }
                    ToastService.updateToast(toastID, 'Erro cálculo!', errMsg, 4000, 'error');
                });
        };

        $scope.showConfigCols = function () {
            //var contactID = 'ECMD';
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/configColumns.html?' + this.buildVersion,
                controller: 'ConfigColumnsCtrl as ctrl',
                size: 'xl',
                resolve: {
                    columns: function () {
                        return $scope.columns;
                    },
                    //contactID: function () {
                    //    return contactID;
                    //},
                    translation: function () {
                        return $scope.translation;
                    },
                }
            });
            return modalInstance;
        };

        function getColumnLayout() {
            StoreService.getConfigurationColumnLayout().then(function (response) {
                hasConfigurationColumnLayout(JSON.parse(response.data));
            });
        }

        function hasConfigurationColumnLayout(columns) {
            if (columns) {
                sortColumns(columns);
                hideColumns(columns);
            }
            else {
                generateDefaultColumns();
            }
        }

        function sortColumns(columns) {
            generateDefaultColumns();

            $scope.columns = $scope.columns.sort(function (a, b) {
                return (
                    columns.map(function (e) { return e.name }).indexOf(a.name) - columns.map(function (e) { return e.name }).indexOf(b.name)
                );
            });
        }

        function hideColumns(columns) {
            $scope.columns.map(function (col) {
                columns.map(function (c) {
                    var sameColumn = c.name == col.name;
                    if (c.hide && sameColumn)
                        col.hide = c.hide;
                });
            });
        }

        function formatExcelData(data) {
            var allColumns = createArrayColumns();
            var dataShownOnScreen = filterDataShownOnScreen(data, allColumns);
            var formatedData = formatDataForDownload(dataShownOnScreen, allColumns);
            changeColumnName(formatedData, allColumns);
            removedNullValues(formatedData, allColumns);
            return formatedData;
        }

        function createArrayColumns() {
            return $scope.columns.filter(function (col) {
                return !col.hide;
            });
        }

        function filterDataShownOnScreen(data, allColumns) {
            var dataShownOnScreen = [];
            data.filter(function (line) {
                dataShownOnScreen.push(allColumns.map(function (col) {
                    if (line.hasOwnProperty(col.name)) return line[col.name];
                }));
            });
            return dataShownOnScreen;
        }

        function formatDataForDownload(dataShownOnScreen, allColumns) {
            var dataObject = {};
            var result = [];
            dataShownOnScreen.map(function (data) {
                allColumns.map(function (col, index) { dataObject[col.name] = data[index] });
                result.push(dataObject);
                dataObject = {};
            });
            return result;
        }

        function changeColumnName(formatedData, allColumns) {
            formatedData.map(function (line) {
                allColumns.map(function (col) {
                    if (line.hasOwnProperty(col.name)) {
                        line[col.display] = line[col.name];
                        delete line[col.name];
                    }
                });
            });
            return formatedData;
        }

        function removedNullValues(formatedData, allColumns) {
            formatedData.map(function (line) {
                allColumns.map(function (col) {
                    if (line.hasOwnProperty(col.display)) {
                        if (!line[col.display]) line[col.display] = '';
                    }
                    if (col.translationPrefix) {
                        //console.log(line);
                        //var lineCol = line[col.display];
                        //var lineVal = $scope.getTranslation(col.translationPrefix + line[col.display]);
                        line[col.display] = $scope.getTranslation(col.translationPrefix + line[col.display]);
                    }

                });
            });
            return formatedData;
        }
    }
]);